import { NAME as name } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const ProvozovnaServisniPersonal = {
	name,
	router,
	apiProvider,
};
